// nx environment variables

const defaultTestEnvironment = {
    ACCOUNT_API_URL: 'http://account.api.example.com',
    ACCOUNT_DEFAULT_PASSWORD: null,
    ACCOUNT_DEFAULT_USER: null,
    ACCOUNT_ENABLE_REDUX_LOGGER: false,
    ACCOUNT_ENABLE_MOCK_SERVICE_WORKER: false
};

const nxEnvironment = {
    ACCOUNT_API_URL: process.env.NX_ACCOUNT_API_URL,
    ACCOUNT_DEFAULT_PASSWORD: process.env.NX_ACCOUNT_DEFAULT_PASSWORD as string,
    ACCOUNT_DEFAULT_USER: process.env.NX_ACCOUNT_DEFAULT_USER,
    ACCOUNT_ENABLE_REDUX_LOGGER: process.env.NX_ACCOUNT_ENABLE_REDUX_LOGGER === 'true',
    ACCOUNT_ENABLE_MOCK_SERVICE_WORKER: process.env.NX_ACCOUNT_ENABLE_MOCK_SERVICE_WORKER === 'true'
};

export const {
    ACCOUNT_API_URL,
    ACCOUNT_DEFAULT_PASSWORD,
    ACCOUNT_DEFAULT_USER,
    ACCOUNT_ENABLE_REDUX_LOGGER,
    ACCOUNT_ENABLE_MOCK_SERVICE_WORKER
} = process.env.NODE_ENV === 'test' ? defaultTestEnvironment : nxEnvironment;
